import Blogs from "./components/blogs";

export default function MainPage() {
  return (
    <div className="p-5 text-white text-center">
        <h1 className="text-5xl text-center text-white black-ops-font">
        Welcome to my Blog!!
        </h1>
        <p>View my latest blogs!</p>
        <Blogs />
    </div>
  )
}
